import React, { useState } from 'react'
import Creatable from 'react-select/creatable'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Tabs, Menu } from 'antd'

import { BiSelectMultiple } from 'react-icons/bi'

import { normalize, stringifyDate, useListData, usePet, useToggle } from '../../modules'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'
import NewInventoryItem from './newinventoryitem'
import EditItem from './editItem'
import { clearAccQueue, modifyAccItem } from '../../store/actions'
import { useHistory } from 'react-router-dom'

const { TabPane } = Tabs

const NewOutInvoice = ({ toggle, visible, onPerform }) => {
    const { queue } = useSelector(state => state.accounting)
    const dispatch = useDispatch()

    const history = useHistory()

    const [clients, setClients] = useState([])
    const [client, setClient] = useState()
    const [selected, setSelected] = useState(null)
    const [key, setKey] = useState(null)
    const [item, setItem] = useState([])
    const [string, setString] = useState('')
    const [code, setCode] = useState('')

    const [newItem, toggleNewItem] = useToggle()
    const [editModal, toggleEditModal] = useToggle()

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const [{ }, getClients] = usePet('clients', {}, { notify: true, callback: ({ data }) => setClients(data), logOutOnError: false })

    const onComplete = () => {
        dispatch(clearAccQueue())
        history.push('/app/sent-invoices')
    }

    const [{ loading: newLoading }, newInvoice] = usePet('newOutInvoice', {
        commit: false, 
        items: queue.map(itm => ({
            item: itm.item._id, 
            bulkCount: itm.bulk, 
            quantity: itm.contains, 
            sp: itm.price,
            discount: itm.discount,
            vat: itm.vat
        })), 
        client: client?.label
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Creating invoice...' } })

    const [{ loading: newCmLoading }, newInvoiceAndCommit] = usePet('newOutInvoice', {
        commit: true,
        items: queue.map(itm => ({
            item: itm.item._id, 
            bulkCount: itm.bulk, 
            quantity: itm.contains,  
            sp: itm.price,
            discount: itm.discount,
            vat: itm.vat
        })), 
        client: client?.label
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Creating invoice...' } })

    const selectItems = (item, i) => {
        setSelected({
            item,
            ...item
        })
        setKey(i)
        toggleEditModal()
    }

    return (
        <Modal
            h="h-auto my-5"
            // w="w-5/6 md:w-4/5 xl:w-3/5 2xl:w-2/5 mt-5"
            align="items-start"
            title="Create New Invoice"
            toggle={toggle}
            visible={visible}>
            {
                newItem &&
                <NewInventoryItem
                    string={string}
                    onPerform={ x => {
                        setItem([...item, { ...x, label: x.name, value: x }])
                    }}
                    toggle={toggleNewItem}
                    visible={newItem} />
            }
            {
                editModal &&
                <EditItem
                    onPerform={ ({ bulk, contains, bp, discount, vat }) => {
                        dispatch(modifyAccItem(key, bulk, contains, bp, vat, discount ))
                    } }
                    record={ selected }
                    toggle={ toggleEditModal }
                    visible={ editModal } />
            }
            <div className="sm:flex items-center mb-8">
                {/* <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" /> */}
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Client
                    </label>
                    <Creatable
                        value={client}
                        onCreateOption={val => {
                            let temp = [...clients]
                            temp.push(val)
                            setClients(temp)
                            setClient({ label: val, value: val })
                        }}
                        onChange={setClient}
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={clients.map(sup => ({ label: sup, value: sup === 'All Clients' ? 'All' : sup }))}
                        placeholder="Select Client" />
                </div>
            </div>
            {
                queue.length > 0 ?
                    <table className="table-auto w-full">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-left">No</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Item</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Quantity</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Price</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Disc</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Tax</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Total</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center"></div>
                                </th>
                            </tr>
                        </thead>
                        {/* Table body */}
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                            {
                                queue.map((rec, key) =>
                                    <tr>
                                        <td className="p-2">
                                            <div className="text-center">{key + 1}.</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="">{rec.item.name}</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">{ rec.bulk } X { rec.contains } ({ rec.bulk * rec.contains })</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="text-left">Ksh. {rec.price}</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">Ksh. { normalize(rec?.discount) }</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">{rec?.vat}</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">Ksh. { normalize((rec.bulk * rec.contains) * (rec.price - rec.discount)) }</div>
                                        </td>
                                        <td className="p-2">
                                            <button onClick={ () => selectItems({
                                                ...rec,
                                                bulk: rec.bulkCount,
                                                containing: rec.contains,
                                                bp: rec.price
                                            }, key) } className="btn hisani-btn-green text-white">
                                                <span className="hidden xs:block mr-2">Edit</span>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                :
                <div className="w-full h-16 flex items-center justify-center">
                    <p className="font-semibold text-base">Please select items to add to invoice</p>
                </div>
            }
            <div className="flex justify-end mt-2">
                <button disabled={ newCmLoading } onClick={ newInvoiceAndCommit } className="text-white bg-yellow-600 hover:bg-yellow-700 focus:ring-4 focus:ring-yellow-300 mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create & Commit Invoice</button>
                <button disabled={ newLoading } onClick={ newInvoice } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Invoice</button>
                <button onClick={ toggle } className="text-white bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default NewOutInvoice